import { useContext } from "react";
import { ProfessionalsWithRoleContext } from "@/contexts/ProfessionalWithRoleContext";

export function useProfessionalsWithRole() {
	const value = useContext(ProfessionalsWithRoleContext);

	return value;
}
